export enum FrontErrorCodes {
  RefreshTokenError = 1,
  IdleTimeout,
  LauncherSocketInitError,
  LauncherSocketClosed,
  LauncherSocketAuthError,
  JackpotSocketAuthError,
}
